// extracted by mini-css-extract-plugin
export default {"mCard":"JB-z","image":"KB-z","imageNoBackground":"LB-z","fullWidth":"MB-z"};